import { useState } from "react";
import { ShieldCheck, ChevronDown, Check, X } from "lucide-react";
import { nom004Local } from "../lib/calc";

const LEVELS = {
  verde: { dot: "bg-emerald-500", chip: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "Cumple NOM-004" },
  amarillo: { dot: "bg-amber-500", chip: "bg-amber-50 text-amber-700 border-amber-200", label: "Cumplimiento parcial" },
  rojo: { dot: "bg-red-500", chip: "bg-red-50 text-red-700 border-red-200", label: "Incompleto" },
};

export const Nom004Badge = ({ nom004, consultation, compact = false, testid = "nom004-badge" }) => {
  const [open, setOpen] = useState(false);
  const n = nom004 || (consultation ? nom004Local(consultation) : null);
  if (!n) return null;
  const lv = LEVELS[n.level] || LEVELS.rojo;
  return (
    <div className="relative inline-block" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 text-[11px] font-bold px-2.5 py-1 rounded-full border transition-all ${lv.chip}`}
        data-testid={`${testid}-toggle`}
      >
        <span className={`w-2.5 h-2.5 rounded-full ${lv.dot}`} />
        <ShieldCheck size={12} />
        {compact ? `${n.score}%` : `NOM-004 · ${n.score}%`}
        <ChevronDown size={11} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute z-50 mt-1.5 right-0 w-64 bg-white rounded-2xl border border-stone-200 shadow-xl p-3" data-testid={`${testid}-detail`}>
          <p className="text-xs font-semibold text-brand-ink mb-1">{lv.label} · {n.passed}/{n.total}</p>
          <ul className="space-y-1">
            {n.items.map((it) => (
              <li key={it.key} className="flex items-center gap-2 text-xs">
                {it.ok ? <Check size={13} className="text-emerald-600 shrink-0" /> : <X size={13} className="text-red-500 shrink-0" />}
                <span className={it.ok ? "text-brand-ink/80" : "text-red-600 font-medium"}>{it.label}</span>
              </li>
            ))}
          </ul>
          <p className="text-[10px] text-muted-foreground mt-2">Evaluación automática de los elementos obligatorios (NOM-004). No sustituye el criterio del médico.</p>
        </div>
      )}
    </div>
  );
};

export default Nom004Badge;
